import { getStrikethroughPromoDiscount } from '../../../shared/utils/product/product';

import { BundleData, ProductData } from '../../../shared/types/graphql-types';

export function getProductSubtotal(
  quantity: number,
  product: ProductData,
  isLoggedIn,
  isStaggered = false,
  totalQuantity: number
) {
  let price;

  const { potentialPromotions = [] } = product;
  const { originalRetailValue: instantPromotionOriginalRetailValue = 0 } =
    potentialPromotions?.find(promo => promo?.instantPromotion) || {};

  if (
    process.env.__FF_INSTANT_PRICE_STRIKE_THROUGH__ === 'true' &&
    isLoggedIn &&
    instantPromotionOriginalRetailValue
  ) {
    if (totalQuantity < 4) {
      price = instantPromotionOriginalRetailValue;
    } else if (totalQuantity >= 4) {
      const discount = getStrikethroughPromoDiscount(product, isStaggered);
      const calculatedDiscount = discount / quantity;
      price = instantPromotionOriginalRetailValue - calculatedDiscount;
    } else {
      price = product?.mapPrice?.value || product?.price?.value;
    }
  } else if (product?.mapRuleSatisfied && product?.mapPrice) {
    if (product?.mapDisplayRule?.mapPriceDisplay === false) {
      price = undefined;
    } else {
      price = product?.mapPrice?.value;
    }
  } else {
    price = product?.price?.value;
  }

  return (price ?? 0) * (quantity || 0);
}

export function getPrebuiltSubtotal(
  quantity: number,
  prebuilt: BundleData,
  isLoggedIn
) {
  const prebuiltQuantity = 4;
  let price1;
  let price2;

  if (prebuilt?.product1) {
    price1 = getProductSubtotal(
      prebuiltQuantity,
      prebuilt.product1,
      isLoggedIn,
      false,
      prebuiltQuantity * 2
    );
  }

  if (prebuilt?.product2) {
    price2 = getProductSubtotal(
      prebuiltQuantity,
      prebuilt.product2,
      isLoggedIn,
      false,
      prebuiltQuantity * 2
    );
  }

  const finalPrice = price1 + price2;

  return finalPrice * (quantity || 0);
}
